import { authHeader } from '../_helpers';
import axios from 'axios';

export const sellerService = {
    getSellers,
    addSeller
};

axios.defaults.headers.common = authHeader();

function getSellers() {
    let token = localStorage.getItem('access_token')

    return axios.get(`/users/seller/create/list/?access_token=${token}`).then(handleResponse)
        .then(response => {
           
            return response;
        });
}

// Add new seller
function addSeller(data) {
    let token = localStorage.getItem('access_token')

    return axios.post(`/users/seller/create/list/?access_token=${token}`, data)
    .then(handleResponse)
        .then(response => {
            return response;
        });
}

function handleResponse(response) {
    if(response.status === 200) {
        if(response.seller_list){
            if(response.seller_list.length == 0){
                const error = 'No data to display';
                return Promise.reject(error);
            }
            return response;
        }
        return response;
    }
    else if(response.status === 201) {
        return response;
    } else if(response.status === 400) {
    }
    return response;
}


// WEBPACK FOOTER //
// ./src/_services/seller.service.js